const listeners = new Set();

export const showPopup = config => {
   listeners.forEach(listener => listener({ type: 'SHOW', ...config }));
};

export const hidePopup = id => {
   listeners.forEach(listener => listener({ type: 'HIDE', id }));
};

export const clearPopups = () => {
   listeners.forEach(listener => listener({ type: 'CLEAR' }));
};

export const subscribe = listener => {
   listeners.add(listener);
   return () => listeners.delete(listener);
};
